import { addEventListenerWithTelemetry } from "./addEventListenerWithTelemetry";
import { bp_product_id, env } from "./constant";

export const getCurrentUrl = () => {
    const { protocol, host, pathname, search, hash } = window.location;
    return `${protocol}//${host}${pathname}${search}${hash}`;
  };
  export const getPageTitle = () => {
    const titleElement = document.querySelector('head title');
    return titleElement ? titleElement.innerText : 'Unknown Title';
  };
  const myApp = {
    country: "GB"
  };
  
 export const countryValue = myApp.country;

 const setupClickEvents = () => {
    return addEventListenerWithTelemetry('a', 'click', (event) => {
        const link = event.target;
        if (link.tagName === 'A') {
            return {
                schema: 'iglu:com.bp.jssdk/link_click/jsonschema/1-0-1',
                country: countryValue,
                targetUrl : link.href,
                elementContent : link.innerHTML,
                elementId: link.id || '',
                elementClasses: Array.from(link.classList),
                elementTarget: link.target || '',
                bp_product_id ,
                env,
            };
        }
        return null;
    });
};

const setupButtonClickEvents = () => {
    return addEventListenerWithTelemetry('button', 'click', (event) => {
        const clickedButton = event.target;
        console.log(event)
        return  {
            schema: 'iglu:com.bp.jssdk/button_click/jsonschema/1-0-1',
            country: countryValue,
            buttonId: clickedButton.id,
            buttonText: clickedButton.innerText,
            URL: getCurrentUrl(),
            title: getPageTitle(),
            bp_product_id ,
            env,
    };
        
    });
};

const setupMouseEnterEvents = () => {
    return addEventListenerWithTelemetry('.hoverable-element', 'mouseenter', (event) => {
        const hoveredElement = event.target;
        return {
            schema: 'iglu:com.bp.jssdk/mouseenter/jsonschema/1-0-1',
            country: countryValue,
            elementType: hoveredElement.tagName,
            elementId: hoveredElement.id,
            bp_product_id ,
            env,
        };
    });
};

/*const setupScrollEvents = () => {
    return addEventListenerWithTelemetry(window, 'scroll', () => (
        {
        schema: 'iglu:com.bp.jssdk/scroll_depth/jsonschema/1-0-1',
        country: countryValue,
        bp_product_id ,
        URL: getCurrentUrl(),
        title: getPageTitle(),
        scroll_depth: window.scrollY,
        env,
        }
    ));
};*/

const setupSelectChangeEvents = () => {
    return addEventListenerWithTelemetry('select', 'change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        return {
            schema: 'iglu:com.bp.jssdk/selectChange/jsonschema/1-0-0',
            country: countryValue,
            elementType: 'select-box',
            selectedOption: selectedOption.value,
            bp_product_id ,
            env,
    }});
};

const setupRadioButtonChangeEvents = () => {
    return addEventListenerWithTelemetry('input[type="radio"]', 'change', (event) => {
      const radioButton = event.target;
      return {
        schema: 'iglu:com.bp.jssdk/radioChange/jsonschema/1-0-0',
        country: countryValue,
        elementType: 'radio-button',
        selectedOption: radioButton.value,
        bp_product_id ,
        env,
      };
    });
  };

  const setupCheckboxChangeEvents = () => {
    return addEventListenerWithTelemetry('input[type="checkbox"]', 'change', (event) => {
      const checkbox = event.target;
      const label = checkbox.nextSibling.textContent;
      if (checkbox.checked) {
        return {
          schema: 'iglu:com.bp.jssdk/checkboxChange/jsonschema/1-0-0',
          country: countryValue,
          elementType: 'checkbox',
          value: label,
          bp_product_id ,
          env,
        };
      } 
    });
  };

const setupFocusInEvents = () => {
    return addEventListenerWithTelemetry('input', 'focusin', (event) => {
      const inputElement = event.target;
      const nodeName = inputElement.nodeName;
      const elementType = inputElement.type;
      const elementClasses = Array.prototype.slice.call(inputElement.classList);
      return {
        schema: 'iglu:com.bp.jssdk/focusin/jsonschema/1-0-1',
        country: countryValue,
        formId: "focusin",
        elementId: inputElement.name,
        nodeName,
        elementType,
        elementClasses,
        value: inputElement.value,
        bp_product_id ,
        env,
      };
    });
  };

  const setupFocusOutEvents = () => {
    return addEventListenerWithTelemetry('input', 'focusout', (event) => {
      const inputElement = event.target;
      const nodeName = inputElement.nodeName;
      const elementType = inputElement.type;
      const elementClasses = Array.prototype.slice.call(inputElement.classList);
  
      return {
        schema: 'iglu:com.bp.jssdk/focusout/jsonschema/1-0-1',
        formId: 'focusout',
        country: countryValue,
        elementId: inputElement.name,
        nodeName,
        elementType,
        elementClasses,
        value: inputElement.value,
        bp_product_id ,
        env,
      };
    });
  };

  const setupFormControlChangeEvents = () => {
    return addEventListenerWithTelemetry('input', 'change', (event) => {
        const updatedFormControl = event.target;
        const formId = updatedFormControl.form?.id || '';
        const nodeName = updatedFormControl.nodeName.toUpperCase();
        const type = updatedFormControl.getAttribute('type') || null;
        const elementClasses = Array.from(updatedFormControl.classList);

        return {
            schema: 'iglu:com.bp.jssdk/form_control_change/jsonschema/1-0-1',
            country: countryValue,
            nodeName,
            formId,
            elementId: updatedFormControl.id,
            type,
            elementClasses,
            updatedValue: updatedFormControl.value,
            bp_product_id ,
            env,
        };
    });
};


const setupFormSubmitEvents = () => {
    return addEventListenerWithTelemetry('form', 'submit', (event) => {
        event.preventDefault();
       const formData = new FormData(event.target);
        const formId = event.target.id || '';
        const formClasses = Array.from(event.target.classList);

        const elements = Array.from(formData.entries()).map(([name, value]) => {
            const nodeName = event.target.elements[name].nodeName.toUpperCase();
            const type = event.target.elements[name].getAttribute('type') || null;

            return {
                name,
                value,
                nodeName,
                type,
            };
        });

        return {
            schema: 'iglu:com.bp.jssdk/form-submit/jsonschema/1-0-1',
            country: countryValue,
            formId,
            formClasses,
            elements,
            bp_product_id ,
            env,
        };
    });
};
export {
    setupClickEvents,
    setupButtonClickEvents,
    setupMouseEnterEvents,
    //setupScrollEvents,
    setupSelectChangeEvents,
    setupRadioButtonChangeEvents,
    setupCheckboxChangeEvents,
    setupFocusInEvents,
    setupFocusOutEvents,
    setupFormControlChangeEvents,
    setupFormSubmitEvents
}